import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/api";
import { Package, Layers, Newspaper, Inbox, MessageSquare, Briefcase, ArrowRight } from "lucide-react";

export default function AdminDashboard() {
  const [summary, setSummary] = useState(null);
  const [enquiries, setEnquiries] = useState([]);

  useEffect(() => {
    api.get("/admin/summary").then((r) => setSummary(r.data));
    api.get("/admin/enquiries").then((r) => setEnquiries((r.data || []).slice(0, 5)));
  }, []);

  const cards = [
    ["Products", summary?.products, "/admin/products", Package],
    ["Categories", summary?.categories, "/admin/categories", Layers],
    ["Blog Posts", summary?.blog_posts, "/admin/blog", Newspaper],
    ["Case Studies", summary?.case_studies, "/admin/case-studies", Briefcase],
    ["Testimonials", summary?.testimonials, "/admin/testimonials", MessageSquare],
    ["Enquiries (new)", summary?.enquiries_new, "/admin/enquiries", Inbox],
  ];

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-heading font-bold text-3xl text-[#1C1C1C]">Dashboard</h1>
      <p className="mt-2 text-[#4B5563] font-body">Overview of your catalog and recent activity.</p>

      <div className="mt-8 grid grid-cols-2 lg:grid-cols-3 gap-4">
        {cards.map(([label, val, href, Icon]) => (
          <Link key={label} to={href} className="bg-white border border-[#E5E7EB] hover:border-[#C1121F] transition-colors p-6 group" data-testid={`stat-${label.toLowerCase().replace(/\s+/g, "-")}`}>
            <div className="flex items-center justify-between">
              <Icon size={20} className="text-[#C1121F]" />
              <ArrowRight size={16} className="text-[#A3A3A3] group-hover:text-[#C1121F] group-hover:translate-x-1 transition-all" />
            </div>
            <div className="mt-6 font-heading font-bold text-3xl text-[#1C1C1C]">{val ?? "—"}</div>
            <div className="text-xs uppercase tracking-wider text-[#4B5563] mt-1">{label}</div>
          </Link>
        ))}
      </div>

      <div className="mt-12">
        <div className="flex items-center justify-between mb-4">
          <h2 className="font-heading font-bold text-xl text-[#1C1C1C]">Recent enquiries</h2>
          <Link to="/admin/enquiries" className="text-sm font-heading font-semibold text-[#C1121F] inline-flex items-center gap-1">View all <ArrowRight size={14} /></Link>
        </div>
        <div className="bg-white border border-[#E5E7EB]">
          {enquiries.length === 0 ? (
            <div className="p-8 text-center text-[#4B5563] font-body">No enquiries yet.</div>
          ) : (
            <table className="w-full text-sm">
              <thead className="border-b border-[#E5E7EB] text-left">
                <tr>
                  <Th>Name</Th><Th>Email</Th><Th>Company</Th><Th>Type</Th><Th>Date</Th>
                </tr>
              </thead>
              <tbody>
                {enquiries.map((e) => (
                  <tr key={e.id} className="border-b border-[#F5F5F5]" data-testid={`enquiry-row-${e.id}`}>
                    <Td><div className="font-heading font-medium text-[#1C1C1C]">{e.name}</div></Td>
                    <Td>{e.email}</Td>
                    <Td>{e.company || "—"}</Td>
                    <Td><span className="chip bg-[#F5F5F5] text-[#1C1C1C]">{e.type}</span></Td>
                    <Td className="text-[#4B5563]">{new Date(e.created_at).toLocaleDateString()}</Td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}

function Th({ children }) { return <th className="px-5 py-3 font-heading font-semibold text-xs uppercase tracking-wider text-[#4B5563]">{children}</th>; }
function Td({ children, className = "" }) { return <td className={`px-5 py-4 font-body ${className}`}>{children}</td>; }
